<template>
  <div>
    <h6 v-if="item.publisher" class="subheader text-center"><strong>Publisher:</strong> {{item.publisher}}</h6>
    <h6 v-if="item.source" class="subheader text-center"><strong>Source:</strong> {{item.source}}</h6>
    <ez-modal-ogl v-if="item.ogl"></ez-modal-ogl>
  </div>
</template>

<script>
import EzModalOgl from "@/components/shared/_VueEzModalOgl";

export default {
  name: "rulebook-footer",
  components: {
    EzModalOgl
  },
  props: ["item"]
};
</script>
